package one.healthium.log_weight.ui.internal

internal sealed interface LogWeightEvents {
    data class OnWeightAdded(
        val delta: Float,
    ) : LogWeightEvents
}